import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import usersActionCreators from '../../store/users/action-creators/index';
import UserIndex from './UserIndex';
import UserDetail from './UserDetail';

class UserContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    this.props.loadUserContainer();
  }

  componentWillUnmount() {
    this.props.unmountUserContainer();
  }

  render() {
    return this.props.userContext.hasScope('admin') ? (
      <Fragment>
        <Route component={UserIndex} exact path="/admin/users" />
        <Route component={UserDetail} path="/admin/users/:userGuid" />
      </Fragment>
    ): (
      <Fragment>
        <Route component={UserIndex} exact path="/users" />
        <Route component={UserDetail} path="/users/:userGuid" />
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadUserContainer: () => {
      return dispatch(usersActionCreators.loadUserContainer());
    },
    unmountUserContainer: () => {
      return dispatch(usersActionCreators.unmountUserContainer());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserContainer));
